import { render, staticRenderFns } from "./EditTask.vue?vue&type=template&id=d5e9f456&scoped=true&"
import script from "./EditTask.vue?vue&type=script&lang=ts&"
export * from "./EditTask.vue?vue&type=script&lang=ts&"
import style0 from "./EditTask.vue?vue&type=style&index=0&id=d5e9f456&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e9f456",
  null
  
)

export default component.exports